import React from 'react';
import RecordEditor from './RecordEditor';
import NewRecordEditor from './NewRecordEditor';

interface RecordEditorsProps {
  selectedZone: any;
  editingRecord: any;
  showNewRecord: boolean;
  onUpdateRecord: (recordId: string, updateData: any) => Promise<void>;
  onCreateRecord: (recordData: any) => Promise<void>;
  onCancelEdit: () => void;
  onCancelNew: () => void;
}

const RecordEditors: React.FC<RecordEditorsProps> = ({
  selectedZone,
  editingRecord,
  showNewRecord,
  onUpdateRecord,
  onCreateRecord,
  onCancelEdit,
  onCancelNew,
}) => {
  return (
    <>
      {editingRecord && (
        <RecordEditor
          record={editingRecord}
          zoneName={selectedZone.name}
          onSave={onUpdateRecord}
          onCancel={onCancelEdit}
        />
      )}

      {showNewRecord && (
        <NewRecordEditor
          zoneName={selectedZone.name}
          onCreate={onCreateRecord}
          onCancel={onCancelNew}
        />
      )}
    </>
  );
};

export default RecordEditors;